var map = {
	"./daniel-siebert.jpg": "255b",
	"./example-person.jpg": "ec08",
	"./jonas-maier.jpg": "0cb7",
	"./marleen-finsterle.jpg": "cda3",
	"./moni-hagel.jpg": "b964",
	"./pauline-martin.jpg": "101b",
	"./romy-scheffold.jpg": "3cfe",
	"./silke-maier.jpg": "95c9",
	"./simon-bochtler.jpg": "2ead",
	"./sofia-gerner.jpg": "7192"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0b8";